export const data = {
  primary: [
    {
      key: 'newItem',
      name: 'New',
      icon: 'Add',
      ariaLabel: 'New. Use left and right arrow keys to navigate',
      onClick: () => { return; },
    },
    {
      key: 'upload',
      name: 'Upload',
      icon: 'Upload',
      onClick: () => { return; },
    },
    {
      key: 'share',
      name: 'Share',
      icon: 'Share',
      onClick: () => { return; }
    },
    {
      key: 'newItem2',
      name: 'New',
      icon: 'Add',
      ariaLabel: 'New. Use left and right arrow keys to navigate',
      onClick: () => { return; },
    },
    {
      key: 'upload2',
      name: 'Upload',
      icon: 'Upload',
      onClick: () => { return; },
    },
    {
      key: 'share2',
      name: 'Share',
      icon: 'Share',
      onClick: () => { return; }
    },
    {
      key: 'newItem3',
      name: 'New',
      icon: 'Add',
      ariaLabel: 'New. Use left and right arrow keys to navigate',
      onClick: () => { return; },
    },
    {
      key: 'upload3',
      name: 'Upload',
      icon: 'Upload',
      onClick: () => { return; },
    },
    {
      key: 'share3',
      name: 'Share',
      icon: 'Share',
      onClick: () => { return; }
    },
    {
      key: 'newItem4',
      name: 'New',
      icon: 'Add',
      ariaLabel: 'New. Use left and right arrow keys to navigate',
      onClick: () => { return; },
    },
    {
      key: 'upload4',
      name: 'Upload',
      icon: 'Upload',
      onClick: () => { return; },
    },
    {
      key: 'share4',
      name: 'Share',
      icon: 'Share',
      onClick: () => { return; }
    }
  ],
  overflow: []
};
